import common from "../common";

export default class Swipe extends PIXI.Container {
    constructor(swipeDirection, swipesRequired = null) {
        super();
        this.initialPoint = null;
        this.previousPoint = null;
        this.currentDirection = null;
        this.previousDirection = null;
        this.swipeCounter = 0;

        this._swipeDirection = swipeDirection;

        if (swipesRequired !== null)
            this.swipesRequired = swipesRequired;

        this.interactive = true;
        this.hitArea = new PIXI.Rectangle((common.STAGE_WIDTH - P3.View.width) * 0.5, 0, 4000, 4000);

        this.pointerup = (event) =>{
            this.swipeEnd(event);
        };
        this.pointerupoutside = (event)=>{
            this.swipeEnd(event);
        };
        this.pointerdown = (event) =>{
            this.swipeStart(event);
        };
        this.pointermove = (event) =>{
            this.swipeMove(event);
        };

        this.signals = {};
        this.signals.swipingComplete = new P3.utils.MiniSignal();
        this.signals.singleSwipe = new P3.utils.MiniSignal();
        this.signals.swipeStart = new P3.utils.MiniSignal();
        this.signals.swipeEnd = new P3.utils.MiniSignal();
        this.signals.swipeMoving = new P3.utils.MiniSignal();
    }

    swipeStart(event) {
        this.isDragging = true;
        this.initialPoint = this._swipeDirection === Swipe.DIRECTION_HORIZONTAL ? event.data.global.x : event.data.global.y;
        this.previousPoint = this.initialPoint;
        this.signals.swipeStart.dispatch(event);
    }

    swipeEnd(event) {
        this.signals.swipeEnd.dispatch(event);

        if (!this.isDragging) return;
        this.isDragging = false;
    }

    swipeMove(event) {
        if (!this.isDragging) return;

        this.signals.swipeMoving.dispatch(event);

        let newPos = this._swipeDirection === Swipe.DIRECTION_HORIZONTAL ? event.data.global.x : event.data.global.y;
        this.detectSwipeDirection(newPos);

        if (this.previousDirection !== this.currentDirection) {
            this.swipeCounter++;

            if (this.swipeCounter === this.swipesRequired) {
                this.signals.swipingComplete.dispatch(event);
                this.swipeCounter = 0;
            }
            this.signals.singleSwipe.dispatch(event);
        }

        this.previousPoint = this._swipeDirection === Swipe.DIRECTION_HORIZONTAL ? event.data.global.x : event.data.global.y;
        this.previousDirection = this.currentDirection;
    }

    destroy() {
        this.signals = {};
        this.hitArea = null;
        super.destroy();
    }

    detectSwipeDirection(newPos){
        let diff = newPos - this.previousPoint;
        let absDiff = Math.abs(this.initialPoint - newPos);

        if (diff > 0 && absDiff > 350) {
            this.initialPoint = newPos;
            this.currentDirection = this._swipeDirection === Swipe.DIRECTION_HORIZONTAL ? "right" : "up";
        } else if (diff < 0 && absDiff > 350) {
            this.initialPoint = newPos;
            this.currentDirection = this._swipeDirection === Swipe.DIRECTION_HORIZONTAL ? "left" : "down";
        }
    }
}

Swipe.DIRECTION_HORIZONTAL = "horizontal";
Swipe.DIRECTION_VERTICAL = "vertical";